export default __webpack_public_path__ + "static/media/JoinAnimation.332cfc27.gif";